import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Button, TextField, Typography, Select, MenuItem, FormControl, InputLabel, Chip, Stack, useTheme, IconButton, CardContent, Card, Collapse } from "@mui/material";
import { useState, useEffect } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Snackbar, Alert } from '@mui/material';
import { formControlStyle } from "../../utils/theme";
const ChipPopup = ({ open, onClose, label, value, onSave, onSubmitToApprover, data , onShowToast}) => {

  const theme = useTheme();
  const [inputValue, setInputValue] = useState(value || "");
  const [reasonCode, setReasonCode] = useState("");
  const [comments, setComments] = useState("");
  const [expandedHistory, setExpandedHistory] = useState(false);
  

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleSave = () => {
    onSave(inputValue, reasonCode, comments);
  };

  const handleApproveClick = () => {
    if (onSubmitToApprover) {
      onSubmitToApprover(data);   // <-- sends full row back to parent
    }
    onShowToast();
  };

  const handleCloseToast = () => {
    // setOpenToast(false);
  };

  const handleToggleHistory = () => {
    setExpandedHistory(prev => !prev);
    setInputValue("");
    setReasonCode("");
    setComments("");
  };

  const mockHistory = [
    {
      version: "196.0",
      modifiedDate: "9/26/2025 7:17 PM",
      modifiedBy: "Alejandro Caliz",
      changes: [
        { field: "Writeback Date", oldValue: "9/1/2025", newValue: "9/5/2025" },
        { field: "VAR (wk) - Approved SS vs IO", oldValue: "0.00", newValue: "0.50" }
      ]
    },
    {
      version: "195.0",
      modifiedDate: "9/15/2025 12:26 AM",
      modifiedBy: "Jonathan Quintana",
      changes: [
        { field: "NewLine", oldValue: "Exists", newValue: "Sent" }
      ]
    }
  ];

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ mb: 1, mt: 1, mr: 1, fontWeight: 'bold' }}>Selected Choice:</Typography>
          <Chip label={label === '?' ? 'Manual Override' : label} color="primary" sx={{ borderRadius: '20px' }} />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <Stack direction='row' gap={2}>
            <Typography sx={{ mb: 1, fontWeight: 'bold' }}>Selected Value:</Typography>
          </Stack>

          <TextField
            fullWidth
            label="Enter custom value"
            variant="outlined"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            autoFocus
            sx={{ mb: 2 }}
            disabled={label === '?' ? false : true}
            type="number"
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <Typography sx={{ mb: 1, fontWeight: 'bold' }}>Reason Code:</Typography>
          <FormControl fullWidth  size="small"  sx={{...formControlStyle,mb: 2}}>
            <InputLabel>Reason</InputLabel>
            <Select
              value={reasonCode}
              onChange={(e) => setReasonCode(e.target.value)}
              label="Reason"
            >
              <MenuItem value="reason0">Reason 0</MenuItem>
              <MenuItem value="reason1">Reason 1</MenuItem>
              <MenuItem value="reason2">Reason 2</MenuItem>
              <MenuItem value="reason3">Reason 3</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <TextField
          fullWidth
          label="Add your Comments here"
          variant="outlined"
          value={comments}
           sx={{...formControlStyle}}
          onChange={(e) => setComments(e.target.value)}
        />

        <Box sx={{ display: 'flex' }}>
          <Typography sx={{ mt: 2 }}>Version History:</Typography>
          <IconButton sx={{ mt: 1 }} onClick={handleToggleHistory}>
            <ExpandMoreIcon />
          </IconButton>
        </Box>

        <Collapse in={expandedHistory}>
          {mockHistory.map((item, index) => (
            <Card key={index} sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="subtitle2" fontWeight={600}>
                  Modified By: {item.modifiedBy}
                </Typography>
                <Typography variant="subtitle2" fontWeight={700}>
                  Version {item.version}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Modified on {item.modifiedDate}
                </Typography>

                <Typography variant="body2" fontWeight="bold">Changes:</Typography>
                {item.changes.map((change, idx) => (
                  <Box key={idx} sx={{ mb: 1 }}>
                    <Typography variant="body2"><strong>{change.field}:</strong></Typography>
                    <Typography variant="caption">Old: {change.oldValue}</Typography>
                    <br />
                    <Typography variant="caption">New: {change.newValue}</Typography>
                  </Box>
                ))}
              </CardContent>
            </Card>
          ))}
        </Collapse>
      </DialogContent>

      <DialogActions>
        {/* 🔥 This now does AG-Grid upsertItem() behavior */}
        <Button
          onClick={() => { handleSave(); handleApproveClick(); onClose(); }}
          variant="outlined"
          sx={{
            borderRadius: '50px',
            border: '0.74px solid green',
            color: '#000',
            '&:hover': { backgroundColor: 'green', color: '#fff' }
          }}
        >
          Submit to Approver
        </Button>

        <Button
          onClick={handleSave}
          color="primary"
          variant="outlined"
          sx={{
            borderRadius: '50px',
            color: "#000",
            '&:hover': { backgroundColor: theme.palette.primary.main, color: '#fff' }
          }}
        >
          Confirm
        </Button>

        <Button
          onClick={onClose}
          color="error"
          variant="outlined"
          sx={{
            borderRadius: '50px',
            backgroundColor: '#000',
            color: '#fff',
            '&:hover': { backgroundColor: 'red', color: '#fff' }
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChipPopup;
